<template>
  <div class="warp_contrainer">
    <div class="navCalss">| 预约配置</div>
    <div class="title">
      <span class="t_left">请配置可预约的时间：</span>
      <span class="t_right">历史预约时间：</span>
    </div>
    <!-- 日历区域 -->
    <div class="calendar">
      <div>
        <el-calendar class="calendar_left">
          <template #dateCell="{ data }">
            <div @click="showAddDateDia(data.day)" class="stag">
              <!-- 显示日期 -->
              <span>
                {{ data.day.slice(8) }}
              </span>
              <div
                :class="item.search(data.day) !== -1 ? 'bcolor' : ''"
                v-for="(item, index) of appointmentTimeList"
                :key="index"
              >
                <!-- 判断日期条件 -->
                <div class="timeText">
                  {{
                    (a =
                      item.search(data.day) !== -1 && getToday(data.day)
                        ? "已选"
                        : "")
                  }}
                  <div class="canChoose" style="color: green">
                    {{
                      (a =
                        item.search(data.day) == -1 && getToday(data.day)
                          ? "可选"
                          : "")
                    }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-calendar>
      </div>
      <div>
        <el-calendar class="calendar_right">
          <template #dateCell="{ data }" :value="tableData">
            <!-- 显示日期 -->
            <div>
              {{ data.day.slice(8) }}
            </div>
            <div>
              <div v-for="item of orderList" :key="item.appointmentTimeId">
                <!-- 判断日期条件 -->
                <div class="timeText2">
                  {{
                    data.day == changeDate(item) &&
                    item.status == 2 &&
                    !getToday(data.day)
                      ? "已选"
                      : ""
                  }}
                </div>
              </div>
            </div>
          </template>
        </el-calendar>
      </div>
    </div>
    <!-- 表格部分 -->
    <div class="table">
      <div class="selecT" v-if="roleId == 1">
        <el-select
          v-model="deliveryDate.addressId"
          placeholder="派送地址"
          @change="addressChange()"
          style="width: 400px; margin: 0px auto 0px auto"
        >
          <el-option
            v-for="(item, index) in addressList"
            :key="index"
            :label="item.deliveryTitle"
            :value="item.addressId"
          >
          </el-option>
        </el-select>
      </div>
      <el-alert
        title="添加或修改数据后，需点击“修改保存”按钮，否则数据将不会展示到前台"
        type="warning"
        :closable="false"
        effect="dark"
        show-icon
        style="width: 26%; margin: 10px 0 0px auto"
      >
      </el-alert>
      <div class="table_El">
        <el-table :data="dataList" border style="width: 100%">
          <el-table-column
            prop="appointmentTime"
            align="center"
            width="150px"
            label="已选日期"
          >
            <template slot-scope="scope">
              {{ changeDate(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            width="500px"
            label="预约时间段配置"
            align="periodPojoList"
          >
            <template slot-scope="scope">
              <div style="text-align: left">
                <el-button
                  class="btTime"
                  @click="showSelTimeDia(scope.row)"
                  icon="el-icon-circle-plus"
                >
                  添加时间
                </el-button>
                <el-tag
                  :key="item.id"
                  v-for="(item, index) in scope.row.periodPojoList"
                  :closable="item.appointmentCount == 0"
                  type="success"
                  @close="showDeleteTimeDia(scope.row, index)"
                >
                  {{ item.period }}
                </el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="maxCount"
            align="center"
            label="预约总人数配置"
          >
            <template slot-scope="scope">
              <div id="bookNum">{{ scope.row.maxCount }}人</div>
            </template>
          </el-table-column>

          <el-table-column prop="useCount" align="center" label="已预约人数">
          </el-table-column>
          <el-table-column prop="5" align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="sendData(scope.row)">
                修改保存
              </el-button>
              <el-button
                type="text"
                :disabled="scope.row.useCount !== 0"
                @click="cancelData(scope.row)"
              >
                取消日期
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 添加日期dialog -->
    <el-dialog
      :visible.sync="addDateDialog"
      width="20%"
      v-model="chooseTime"
      center
      :modal-append-to-body="false"
    >
      <p style="margin-left: 30px">添加 ' {{ chooseTime }}' 新日期？</p>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="addDateDialog = false">取 消</el-button>
          <el-button type="primary" @click="addTime()">确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 添加新时间段dialog -->
    <el-dialog
      :visible.sync="addTimeDialog"
      width="26%"
      v-model="selTime"
      center
      :modal-append-to-body="false"
      :destroy-on-close="true"
    >
      <div>
        <!-- <el-time-select
         placeholder="起始时间"
         style="width:100%"
         v-model="selTime.startTime"
         @input="timeChange"
         :picker-options="{
		      	start: '00:00',
		      	step: '01:00',
		      	end: '24:00'
		      }"
         >
       </el-time-select>
       <div class="arrow">↓</div>
       <el-time-select
         placeholder="结束时间"
         v-model="selTime.endTime"
         style="width:100%"
         :picker-options="{
		      	start: '00:00',
		      	step: '02:00',
		      	end: '24:00',
            minTime:selTime.startTime
		      }"
         :disabled="selTime.startTime==''"
         >
       </el-time-select> -->

        <el-time-picker
          is-range
          v-model="value1"
          format="HH:mm"
          range-separator="至"
          @change="newTimeChange"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围"
        >
        </el-time-picker>

        <el-input
          v-model="bookPerNum"
          placeholder="可预约人数"
          autofocus
          style="width: 80%; margin-top: 20px"
        ></el-input>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="addTimeDialog = false">取 消</el-button>
          <el-button
            type="primary"
            :disabled="selTime.endTime == '' || bookPerNum == ''"
            @click="addTimeQuantum()"
            >确 定</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 显示删除时间段确认的Dialog -->
    <el-dialog
      title="提 示"
      :visible.sync="deleteTimeDialog"
      width="30%"
      :close="closeDeleteTimeDia"
      :modal-append-to-body="false"
      center
    >
      <span class="diatext">您确定删除该时间段吗？此操作将影响前台展示</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="deleteTimeDialog = false">取 消</el-button>
          <el-button type="primary" @click="deleteTimeDiaComfirm"
            >确 定</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import * as book from "../../api/book";
import * as mUtils from "../../utils/mUtils";

export default {
  data() {
    return {
      addDateDialog: false,
      addTimeDialog: false,
      deleteTimeDialog: false,
      appointRow: [],
      appointindex: "",
      appointmentTimeList: {
        msg: "",
      },
      realName: "",
      addressId: "",
      roleId: "",
      chooseTime: "",
      selTime: {
        startTime: "",
        endTime: "",
        timequantumInfo: "",
      },
      orderList: [],
      dataList: [],
      deliveryDate: {
        addressId: null,
      },
      addressList: [],
      bookPerNum: "",
      totalPerson: 0,
      value1: [new Date(2021, 9, 10, 0, 0), new Date(2021, 9, 10, 23, 59)],
      time1: "",
      time2: "",
      result: "",
      deliverAddress: "",
      SingleAddressId: "",
    };
  },
  created() {},
  mounted() {
    this.getAdressId();
  },
  beforeUpdate() {},
  watch: {},
  methods: {
    test() {
      this.visible = true;
    },

    newTimeChange(value1) {
      if (!value1) {
        this.selTime.startTime = "";
        this.selTime.endTime = "";
        return;
      }

      this.time1 = this.changeToTime(
        new Date(mUtils.formatDate(value1[0])).getTime()
      );
      this.time2 = this.changeToTime(
        new Date(mUtils.formatDate(value1[1])).getTime()
      );
      this.selTime.startTime = this.changeToTime(
        new Date(mUtils.formatDate(value1[0])).getTime()
      );
      this.selTime.endTime = this.changeToTime(
        new Date(mUtils.formatDate(value1[1])).getTime()
      );
    },

    changeToTime(timeStamp) {
      let date = new Date(timeStamp);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D = date.getDate() + " ";
      let h =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours() + ":";
      let m =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let s = date.getSeconds();

      var str = h + m;
      if (str.toString().length === 4) {
        str = h + ":" + m;
      }

      return str;
    },

    addressChange() {
      this.addressId = this.deliveryDate.addressId;
      this.getTimeList();
    },
    getTimeList(SingleAddressId) {
      let param = {
        addressId: SingleAddressId || this.addressId,
      };
      book.timeList(param).then((res) => {
        if (res.status == 200) {
          this.orderList = res.data.data.list;
          // this.addressId=this.orderList[0].addressId?this.orderList[0].addressId:''
          this.putEffectiveTime();
        } else if (res.status !== 200) {
          this.$message.error("获取预约列表失败");
        }
      });
    },
    // 把status=1的日期放到一个数组中
    putEffectiveTime() {
      this.dataList = [];
      for (var i = 0; i < this.orderList.length; i++) {
        if (
          this.orderList[i].status == 1 ||
          this.orderList[i].status == undefined
        ) {
          this.dataList.push(this.orderList[i]);
        }
      }
      this.appointmentTimeList.msg = this.putTime(this.dataList);
    },
    // 对比选择的日期与今天日期的大小
    getToday(day1) {
      var day2 = new Date();
      day2.setTime(day2.getTime());
      var month =
        day2.getMonth() + 1 < 10
          ? "0" + (day2.getMonth() + 1)
          : day2.getMonth() + 1;
      var date = day2.getDate() < 10 ? "0" + day2.getDate() : day2.getDate();
      var s2 = day2.getFullYear() + "-" + month + "-" + date;
      if (day1 === undefined) {
        return;
      }
      let date1 = day1.replace(/\-/g, "/");
      let date2 = s2.replace(/\-/g, "/");
      return date1 >= date2;
    },
    // handleCloseTag(row,index){
    //   row.periodPojoList.splice(index,1);
    // },
    // 添加新日期
    addTime() {
      this.addDateDialog = false;
      var day = this.chooseTime;
      var date = new Date(day);
      let isChinaStr = date.toString();
      let result = isChinaStr.indexOf("中国") != -1;
      this.result = result;
      var date2 = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
      if (!result) {
        date2 += 86400000;
        // date2 += 50400000;
        // date2 += 39600000;
      }
      if (this.getToday(day)) {
        this.orderList.push({
          appointmentTimeId: this.orderList.length + 1,
          appointmentTime: date2,
          addressId: this.SingleAddressId || this.addressId,
          periodPojoList: [],
          maxCount: 0,
          useCount: 0,
        }),
          this.putEffectiveTime();
        this.appointmentTimeList.msg = this.appointmentTimeList.msg + "," + day;
      } else {
      }
    },
    //获取addressId
    getAdressId() {
      let uselist = mUtils.getStore("userinfo");
      this.realName = uselist.realName || "";
      this.roleId = uselist.roleId;
      this.deliverAddress = uselist.adminId;

      book.deliveryList({ type: 2 }).then((res) => {
        if (res.status !== 200) {
          return this.$message.error("获取用户失败：" + res.msg);
        }
        if (res.data.code !== 0) {
          return this.$message.error("获取错误：" + res.data.msg);
        }
        if (res.data.data.list !== {}) {
          let data = res.data.data.list;
          this.addressList = data;
          for (let i = 0; i < data.length; i++) {
            // if (data[i].contact == this.realName) {
            //   this.addressId = data[i].addressId;
            //   if (this.roleId !== 1)
            //     this.addressList.forEach((dItem, index) => {
            //       if (dItem.adminId == this.deliverAddress) {
            //         this.SingleAddressId = dItem.addressId;
            //         this.getTimeList(dItem.addressId);
            //       }
            //     });

            //   return;
            // }

            if (data[i].adminId == this.deliverAddress) {
              this.addressId = data[i].addressId;
              if (this.roleId !== 1)
                this.addressList.forEach((dItem, index) => {
                  if (dItem.adminId == this.deliverAddress) {
                    this.SingleAddressId = dItem.addressId;
                    this.getTimeList(dItem.addressId);
                  }
                });

              return;
            }
          }
        }
      });
    },
    // 检查点击的日期是否已经存在
    checkTimeExit(obj, day, value) {
      if (value == "appointmentTime") {
        for (var i = 0; i < obj.length; i++) {
          if (this.changeDate(obj[i]) == day && obj[i].status !== -1) {
            return false;
          }
        }
        return true;
      } else if (value == "period") {
        for (var i = 0; i < obj.length; i++) {
          if (obj[i].period == day) return false;
        }
        return true;
      }
    },
    showAddDateDia(day) {
      // if(this.addressId=='')
      // return
      let temRoleId = mUtils.getStore("roleID") || null;
      // 如果不是派送点账号，例如管理员账号，必须选择派送点才可以预约
      // 如果是派送点账号，可以直接预约
      if (this.addressId == "" && temRoleId == 1) {
        this.$message({
          message: "请选择派送地址",
          type: "warning",
        });
        return;
      }

      if (
        this.getToday(day) &&
        this.checkTimeExit(this.orderList, day, "appointmentTime")
      ) {
        this.chooseTime = day;
        this.addDateDialog = true;
      } else {
        this.$message({
          message: "该日期无法选择，已选或是今天之前的时间",
          type: "error",
        });
      }
    },
    // 显示添加时间段dialog
    showSelTimeDia(row) {
      this.selTime.startTime = "";
      this.selTime.endTime = "";
      this.bookPerNum = "";
      this.timequantumInfo = row;
      (this.value1 = [
        new Date(2021, 9, 10, 0, 0),
        new Date(2021, 9, 10, 23, 59),
      ]),
        (this.addTimeDialog = true);
    },
    // 显示删除时间段提示对话框
    showDeleteTimeDia(row, index) {
      this.deleteTimeDialog = true;
      this.appointRow = row;
      this.appointindex = index;
    },
    closeDeleteTimeDia() {
      this.deleteTimeDialog = false;
      this.appointRow = [];
      this.appointindex = [];
    },
    deleteTimeDiaComfirm() {
      // this.handleCloseTag(this.appointRow,this.appointindex)
      let param = {
        appointmentPeriodId:
          this.appointRow.periodPojoList[this.appointindex].appointmentPeriodId,
      };
      book.cancelTime(param).then((res) => {
        if (res.status == 200) {
          this.appointRow = [];
          this.appointindex = [];
          this.getTimeList();
          this.$message.success("删除时间段成功");
        } else if (res.status !== 200) {
          this.$message.error("删除时间段失败");
        }
      });
      this.deleteTimeDialog = false;
    },
    // dialog确定按钮添加新时间段
    addTimeQuantum() {
      let realMaxCount = this.bookPerNum; // 当前时间段对应的人数

      var timestr = this.selTime.startTime + this.selTime.endTime;

      var newtimestr = this.changTimeStr(timestr);

      if (
        !this.checkTimeExit(
          this.timequantumInfo.periodPojoList,
          newtimestr,
          "period"
        )
      ) {
        return this.$message({
          message: "该时段无法选择，已存在",
          type: "error",
        });
      }
      this.timequantumInfo.periodPojoList.push({
        appointmentTimeId: this.timequantumInfo.periodPojoList.length + 1,
        // startTime:
        period: newtimestr,
        appointmentCount: 0,
        maxCount: realMaxCount,
      });
      this.addTimeDialog = false;
      this.selTime.startTime = "";
      this.selTime.endTime = "";
    },

    // 把08:00到10:00时间格式转换为8点-10点
    changTimeStr(str) {
      let str1 = str.substring(0, 5);
      let str2 = str.substring(5, 10);
      let newStr = str1 + "-" + str2;
      return newStr;
    },

    // 调用把0点时间戳转换为正常时间格式
    changeDate(row) {
      let time = row.appointmentTime;
      // if(!this.result)
      // // time+=86400000
      // time += 50400000;

      if (!this.result) {
        // time+=39600000;
        // time+=86400000
        time += 46800000;
      }

      return mUtils.formatDate(new Date(time), 3);
    },

    // 把所有派送列表的时间放到一个数组里
    putTime(obj) {
      var arr = [];
      for (var i = 0; i < obj.length; i++) {
        arr.push(this.changeDate(obj[i]));
      }
      return arr.toString();
    },

    // 将时间段里面的时间转换为时间戳
    changeTimeQ(date, time) {
      var arr = [];
      var date3 = null;
      var date4 = null;
      var date5 = null;

      if (time.length == 0) return arr;
      for (var i = 0; i < time.length; i++) {
        const str1 = time[i].period.substring(0, 5) + ":00";
        const str2 = time[i].period.substring(6, 11) + ":00";

        let basic = 1609430400000;
        let str1FiveStr = time[i].period.substring(0, 5);
        let str2FiveStr = time[i].period.substring(6, 11);
        let min1 = 0;
        let min2 = 0;
        if (str1FiveStr[0] == "0") {
          min1 += str1FiveStr[1] * 1 * 60;
        } else {
          let frontTwoStr = str1FiveStr.substring(0, 2);
          min1 += frontTwoStr * 1 * 60;
        }

        if (str1FiveStr[3] == "0") {
          min1 += str1FiveStr[4] * 1;
        } else {
          let behindTwoStr = str1FiveStr.substring(3, 5);
          min1 += behindTwoStr * 1;
        }

        if (str2FiveStr[0] == "0") {
          min2 += str2FiveStr[1] * 1 * 60;
        } else {
          let frontTwoStr2 = str2FiveStr.substring(0, 2);
          min2 += frontTwoStr2 * 1 * 60;
        }

        if (str2FiveStr[3] == "0") {
          min2 += str2FiveStr[4] * 1;
        } else {
          let behindTwoStr2 = str2FiveStr.substring(3, 5);
          min2 += behindTwoStr2 * 1;
        }

        let startStamp = min1 * 60 * 1000 + basic;
        let endStamp = min2 * 60 * 1000 + basic;

        arr[i] = {
          expireTime: endStamp,
          startTime: startStamp,
          period: time[i].period,
          remark: time[i].remark == undefined ? "" : time[i].remark,
          maxCount: this.timequantumInfo.periodPojoList[i].maxCount,
        };
      }
      return arr;
    },

    // 把所有派送列表的时间放到一个数组里
    putTime(obj) {
      var arr = [];
      for (var i = 0; i < obj.length; i++) {
        arr.push(this.changeDate(obj[i]));
      }
      return arr.toString();
    },

    // 确定修改（添加）日期的（操作上的）按钮
    sendData(row) {
      let howMany = 0;
      row.periodPojoList &&
        row.periodPojoList.forEach((json) => {
          howMany += json.maxCount * 1;
        });
      this.totalPerson = howMany;
      let param = {
        appointmentTime: row.appointmentTime,
        addressId: this.SingleAddressId || row.addressId,
        periodParamList: this.changeTimeQ(
          row.appointmentTime,
          row.periodPojoList
        ),
        maxCount: howMany,
      };

      if (this.changeTimeQ(row.appointmentTime, row.periodPojoList).length < 1)
        return this.$message.error("添加日期失败：未配置预约时间");
      if (param.maxCount - 0 < 1)
        return this.$message.error("添加日期失败：未配置预约人数");

      book.comfirmBt(param).then((res) => {
        if (res.status == 200 && res.data.code == 0) {
          this.$message.success("配置(修改)日期数据成功");
          this.getTimeList(this.SingleAddressId);
        } else if (res.status !== 200 || res.data.code != 0) {
          this.$message.error("配置(修改)日期数据失败");
        }
      });
    },
    cancelData(row) {
      let param = {
        appointmentTimeId: row.appointmentTimeId,
      };
      book.cancelBt(param).then((res) => {
        if (res.status == 200) {
          this.$message.success("取消日期数据成功");
          this.getTimeList(this.SingleAddressId);
        } else if (res.status !== 200) {
          this.$message.error("取消日期数据失败");
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  margin-top: 10px;
  margin-bottom: -5px;

  .t_left {
    margin-right: 50%;
    font-size: 18px;
  }
  .t_right {
    font-size: 18px;
  }
}
.warp_contrainer {
  padding: 3px 20px 50px 20px;
  margin-bottom: 50px;
}
.navCalss {
  font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
    sans-serif;
  font-weight: 650;
  font-size: 18px;
}
.timeText {
  -webkit-transform: scale(0.8);
  width: 148%;
  color: red;
}
.timeText2 {
  -webkit-transform: scale(0.8);
  width: 148%;
  color: rgb(51, 255, 0);
}
.timeText_bottom {
  -webkit-transform: scale(0.8);
  width: 148%;
}
.bcolor {
  background-color: yellow;
}
.btTime {
  margin: 0 5px 5px 0;
}
.einput {
  width: 50px;
  margin-right: 8px;
}
.el-tag {
  margin-bottom: 3px;
}
.arrow {
  width: 100%;
  display: inline-block;
  text-align: center;
}
.diatext {
  width: 100%;
  display: inline-block;
  text-align: center;
  font-size: 18px;
}
.stag:hover {
  color: rgb(255, 238, 1);
}
.table {
  .selecT {
    text-align: right;
  }
  .table_El {
    margin-top: 10px;
  }
}
.calendar::after {
  content: "";
  display: block;
  clear: both;
}
</style>
<style lang="less">
// 设置日历大小
.calendar {
  .calendar_left {
    float: left;
    margin-left: 10px;
  }
  .calendar_right {
    float: right;
    margin-right: 50px;
  }
}
.el-calendar {
  width: 320px;
}
.el-calendar-table .el-calendar-day {
  height: 50px;
}
.el-calendar-day {
  width: 100%;
}
.el-calendar__header {
  width: 300px;
}
.el-calendar__body {
  width: 300px;
  text-align: center;
  margin-left: 15px;
}
.el-calendar-table {
  width: 280px;
}
</style>


// WEBPACK FOOTER //
// config.vue?00d50ac5